var _path, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPercent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.4005 82.9942H53.7757C49.846 82.9942 46.6616 79.8099 46.6616 75.8801V45.9494C46.6616 44.3052 47.2316 42.7157 48.2675 41.4442L59.5799 27.6161C62.4244 24.1358 67.7463 24.1358 70.5908 27.6161L81.9032 41.4442C82.9446 42.7157 83.5091 44.3052 83.5091 45.9494V75.8801C83.5091 79.8099 80.3248 82.9942 76.395 82.9942H76.4005Z",
    fill: "url(#paint0_linear_1846_70115)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4005 82.9942H53.7757C49.846 82.9942 46.6616 79.8099 46.6616 75.8801V45.9494C46.6616 44.3052 47.2316 42.7157 48.2675 41.4442L59.5799 27.6161C62.4244 24.1358 67.7463 24.1358 70.5908 27.6161L81.9032 41.4442C82.9446 42.7157 83.5091 44.3052 83.5091 45.9494V75.8801C83.5091 79.8099 80.3248 82.9942 76.395 82.9942H76.4005Z",
    fill: "url(#paint1_linear_1846_70115)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1846_70115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0438 49.167L72.2022 31.3982C71.7364 26.9258 67.2969 23.9991 63.0054 25.3419L45.9546 30.6638C44.3871 31.1515 43.0388 32.171 42.1345 33.5412L25.6647 58.5337C23.5052 61.8167 24.4095 66.2287 27.6926 68.3882L46.5849 80.8351C49.8679 82.9945 54.28 82.0902 56.4394 78.8072L72.9038 53.8147C73.8081 52.4445 74.2082 50.8003 74.0383 49.167H74.0438ZM69.0124 35.5362C67.4558 37.8984 64.2824 38.5506 61.9202 36.9941C59.558 35.4375 58.9058 32.2642 60.4623 29.9019C62.0189 27.5397 65.1923 26.8875 67.5545 28.444C69.9167 30.0006 70.5689 33.174 69.0124 35.5362Z",
    fill: "url(#paint2_linear_1846_70115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7438 31.4459L73.5326 48.706H73.5269L73.5798 49.2147C73.7387 50.7423 73.3644 52.2799 72.5191 53.5608L72.5188 53.5611L56.0545 78.5536L56.0543 78.5539C54.0352 81.6236 49.9092 82.47 46.8382 80.45L27.9461 68.0033L27.9459 68.0031C24.8762 65.984 24.0298 61.8579 26.0498 58.787L42.5192 33.7951C43.3655 32.5129 44.6266 31.5598 46.0916 31.1039L46.092 31.1038L63.1428 25.7819L63.1431 25.7818C67.156 24.5262 71.308 27.2627 71.7438 31.4459ZM61.6666 37.379C64.2414 39.0756 67.7006 38.3646 69.3973 35.7898C71.0939 33.215 70.3829 29.7558 67.8081 28.0591C65.2333 26.3625 61.7741 27.0735 60.0774 29.6483C58.3808 32.2231 59.0918 35.6824 61.6666 37.379Z",
    stroke: "url(#paint3_linear_1846_70115)",
    strokeWidth: 0.921897
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1256 66.3508C47.8164 66.5293 47.5768 66.4713 47.4068 66.1769C47.3558 66.0885 47.3385 65.9906 47.3549 65.883L49.9547 45.2421C49.9813 45.0501 50.0248 44.8876 50.0854 44.7544C50.1459 44.6213 50.2719 44.4995 50.4633 44.389L51.6338 43.7132C51.943 43.5347 52.1826 43.5927 52.3526 43.8872C52.4036 43.9755 52.4209 44.0735 52.4045 44.1811L49.8047 64.8219C49.7781 65.0139 49.7345 65.1765 49.674 65.3096C49.6281 65.4342 49.5022 65.556 49.296 65.675L48.1256 66.3508ZM58.8247 60.3504C57.8382 60.9199 56.9007 61.098 56.012 60.8848C55.1233 60.6715 54.3944 60.1402 53.8255 59.2909C53.5898 58.9166 53.3912 58.5896 53.2297 58.3098C53.0682 58.0301 52.8758 57.6798 52.6525 57.2591C52.2014 56.3417 52.0909 55.4534 52.3212 54.5941C52.5661 53.7264 53.2039 52.995 54.2345 52.4C55.2798 51.7965 56.2321 51.6098 57.0914 51.8401C57.9654 52.0618 58.6795 52.6016 59.2336 53.4595C59.5011 53.8547 59.7156 54.1922 59.8771 54.4719C60.0386 54.7517 60.2151 55.0914 60.4067 55.4912C60.8725 56.4001 60.9683 57.2969 60.6939 58.1817C60.4342 59.0579 59.8111 59.7808 58.8247 60.3504ZM57.8301 58.6278C58.154 58.4408 58.3661 58.23 58.4663 57.9955C58.5811 57.7525 58.6233 57.5024 58.5926 57.2453C58.5619 56.9882 58.4871 56.7566 58.3681 56.5504C58.185 56.1654 58.0212 55.8477 57.8767 55.5974C57.7237 55.3324 57.5348 55.0391 57.3098 54.7174C57.0996 54.3873 56.818 54.1376 56.4651 53.9684C56.1037 53.7844 55.6874 53.8285 55.2163 54.1005C54.7599 54.364 54.521 54.6982 54.4996 55.1032C54.4697 55.4934 54.5378 55.8664 54.7038 56.222C54.8846 56.5691 55.0515 56.8752 55.2045 57.1402C55.349 57.3905 55.5349 57.6954 55.7621 58.055C55.9106 58.2441 56.0811 58.4205 56.2737 58.5841C56.4811 58.7392 56.7113 58.832 56.9645 58.8625C57.2324 58.8845 57.521 58.8063 57.8301 58.6278ZM45.4993 57.6199C44.5129 58.1894 43.5838 58.3823 42.7121 58.1985C41.8404 58.0147 41.1201 57.4981 40.5512 56.6487C40.3155 56.2745 40.1169 55.9474 39.9554 55.6677C39.7854 55.3732 39.5887 55.0156 39.3654 54.5949C38.9143 53.6775 38.8039 52.7892 39.0341 51.9299C39.279 51.0622 39.9168 50.3308 40.9474 49.7358C41.9928 49.1323 42.9451 48.9456 43.8043 49.1758C44.6783 49.3976 45.3924 49.9374 45.9466 50.7953C46.214 51.1905 46.4328 51.5354 46.6028 51.8298C46.7643 52.1096 46.9408 52.4493 47.1324 52.8491C47.5982 53.758 47.6854 54.6401 47.394 55.4954C47.1173 56.3422 46.4858 57.0504 45.4993 57.6199ZM44.5558 55.9857C44.8797 55.7987 45.0918 55.5879 45.1919 55.3534C45.3068 55.1104 45.3489 54.8603 45.3183 54.6032C45.2876 54.3461 45.2085 54.1071 45.081 53.8862C44.898 53.5012 44.7342 53.1835 44.5897 52.9332C44.4367 52.6682 44.2477 52.3749 44.0227 52.0532C43.8125 51.7231 43.5309 51.4734 43.178 51.3042C42.8251 51.135 42.4131 51.1863 41.942 51.4584C41.4856 51.7219 41.2424 52.0487 41.2125 52.439C41.1826 52.8292 41.2581 53.1979 41.4389 53.545C41.6196 53.8922 41.7865 54.1982 41.9395 54.4632C42.084 54.7135 42.2699 55.0185 42.4971 55.378C42.6394 55.5904 42.8068 55.7784 42.9994 55.942C43.2067 56.0971 43.437 56.1899 43.6902 56.2204C43.9581 56.2424 44.2466 56.1642 44.5558 55.9857Z",
    fill: "#FAFAFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1846_70115",
    x: 7.89707,
    y: 8.41953,
    width: 82.7737,
    height: 90.1824,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.29707
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1846_70115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1846_70115",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1846_70115",
    x1: 65.0881,
    y1: 85.3291,
    x2: 65.0881,
    y2: 27.6435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFCA40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1846_70115",
    x1: 65.0881,
    y1: 85.3291,
    x2: 65.0881,
    y2: 27.6435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFCA40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1846_70115",
    x1: 27.2906,
    y1: 78.7909,
    x2: 77.3637,
    y2: 35.2275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1846_70115",
    x1: 27.9914,
    y1: 29.4962,
    x2: 75.6158,
    y2: 73.7977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPercent);
export default __webpack_public_path__ + "static/media/icon-percent.36dc5387253be53f1c388b1aacec002b.svg";
export { ForwardRef as ReactComponent };